// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2fKQ-","title":"ClientCherryInfo_title__7ICsG","itemText":"ClientCherryInfo_itemText__1QboU"};